export default __webpack_public_path__ + "static/media/BAKA_ikona_web_odabrano-03.e3a6f8cf.svg";